var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _circle, _circle2, _circle3, _path12, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.0937,
    cy: 107.423,
    rx: 47.2578,
    ry: 3.57728,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.4151 74.8078C103.694 69.4095 105.086 56.9057 100.376 48.8993L83.0565 63.9491L75.064 69.4983C80.1519 76.6093 87.1362 80.2062 95.4151 74.8078Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0528 70.0044C103.151 70.0044 106.682 55.5433 100.716 45.5381L83.669 60.896L74.733 53.8618C79.9477 60.8804 80.9547 70.0044 92.0528 70.0044Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.152 37.1812L86.6746 38.8114C86.6746 38.8114 86.2397 27.4878 78.0147 18.7169C72.6319 12.9769 63.9806 8.29421 50.9452 8.51094C42.3603 8.65368 35.8081 11.3732 30.9349 14.5645C15.717 23.7289 16.7224 43.9915 16.7224 43.9915H9.83151C9.83151 43.9915 9.08298 19.355 29.8419 8.17461C35.1149 5.33471 41.7755 3.15236 50.1886 2.70958C63.372 2.01574 75.6237 8.51091 79.8678 12.4626C92.2271 23.5607 93.152 37.1812 93.152 37.1812Z",
    fill: "#EAEAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5129 35.8683C87.5129 35.8683 83.9771 5.30483 51.0233 5.85274C42.4384 5.99548 35.8862 8.71501 31.0131 11.9063C15.7951 21.0707 16.5518 41.3333 16.5518 41.3333H9.90964C9.90964 41.3333 9.1611 16.6968 29.9201 5.51641C35.193 2.6765 41.8536 0.494154 50.2667 0.0513751C63.4501 -0.642465 75.7018 5.85271 79.9459 9.80436C92.3053 20.9025 93.2301 34.523 93.2301 34.523L87.5129 35.8683Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2466 65.5829C87.9351 73.6188 85.3302 86.4654 75.4581 92.7833C63.4686 100.456 53.0673 97.1664 47.4967 88.462C41.926 79.7575 45.413 67.5795 55.2851 61.2617C65.1571 54.9438 77.6759 56.8785 83.2466 65.5829Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8794 61.2978C84.5679 69.3336 80.0332 83.8011 72.2981 88.8367C63.2177 94.7481 49.2609 91.275 44.1295 84.1768C38.5589 75.4724 42.0459 63.2944 51.9179 56.9765C61.79 50.6586 74.3087 52.5933 79.8794 61.2978Z",
    fill: "#FFFEFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.579956 59.7457C-0.176819 70.0031 8.81279 77.3178 15.5457 77.3178C16.4268 77.3178 17.2385 77.1719 17.9839 76.8981V42.4258C9.91255 42.4258 0.579956 50.6909 0.579956 59.7457Z",
    fill: "#EAEAEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.325968 54.0285C-0.258087 65.4134 9.45109 67.8271 15.3446 67.5748C16.2523 67.536 17.0902 67.456 17.8589 67.233L18.9071 39.8195C7.80888 37.6335 0.662402 47.4705 0.325968 54.0285Z",
    fill: "#C4C4C4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.5664,
    y: 37.6338,
    width: 11.4345,
    height: 42.8793,
    rx: 5.71724,
    fill: "#EAEAEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5664 60.5039L86.0009 61.6756V68.5753H74.5664V60.5039Z",
    fill: "#EAEAEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6519 32.9248H72.7167C66.9995 32.9248 61.6236 38.0777 59.8529 42.6778C58.0822 47.2778 59.2674 52.9081 60.1059 55.2893C62.2078 61.2588 67.3365 63.697 67.3365 63.697C67.3365 63.697 67.1683 71.0117 67.6728 71.348C68.1773 71.6844 75.2397 64.9582 75.2397 64.9582C75.2397 64.9582 85.4131 65.883 92.6438 65.883C95.7049 65.883 99.3517 64.0103 101.808 62.1836C106.937 58.3699 108.846 51.0014 106.936 43.2663C105.67 38.1376 99.8389 32.9248 93.6519 32.9248Z",
    fill: "#EAEAEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.571 31.748H72.6358C66.9185 31.748 61.5427 36.901 59.772 41.501C58.0013 46.101 58.6675 52.1788 59.772 54.4489C61.6109 58.2282 67.2549 61.5113 67.2549 61.5113L67.4974 70.4013C67.5012 70.5438 67.6695 70.6171 67.7765 70.5231L75.1582 64.0337H92.5621C95.6233 64.0337 99.1019 62.7494 101.558 60.9228C107.948 56.1712 108.765 49.8246 106.855 42.0895C105.589 36.9608 99.758 31.748 93.571 31.748Z",
    fill: "#C7C7C7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.9057,
    cy: 47.892,
    r: 3.02678,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.976,
    cy: 47.892,
    r: 3.02678,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.3822,
    cy: 47.892,
    r: 3.02678,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.829896 56.8872C0.0495399 65.2414 9.65799 71.0122 15.5515 70.76C16.4592 70.7211 17.2971 70.6412 18.0658 70.4182V42.3419C10.8351 42.0057 1.44247 50.3292 0.829896 56.8872Z",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3945,
    y: 37.4658,
    width: 11.4345,
    height: 42.8793,
    rx: 5.71724,
    fill: "#BCBCBC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16440_10255)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.9297,
    y: 87.0723,
    width: 20.8511,
    height: 14.6294,
    rx: 7.06248,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2461,
    y: 83.2041,
    width: 24.3824,
    height: 14.6294,
    rx: 7.06248,
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16440_10255"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.9297,
    y: 87.0723,
    width: 20.8511,
    height: 14.6294,
    rx: 7.06248,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.971fe5c2487c33c8362d7eb1bb19d54b.svg";
export { ForwardRef as ReactComponent };